function isJemma() {
  const href = window.location.href;
  return (href || '').toLowerCase().indexOf('jemma') !== -1;
}

export default isJemma;
